<template>
	<div>
		<ModalHeaderTitle :title="'Inicia Sesión'" />

		<form action="" @submit.prevent="login" v-if="!recuperar">
			<div class="field">
				<div class="control has-icons-left ">
					<input
					class="input"
					:class="errors.email ? 'is-danger' : ''"
					v-model="email"
					type="email"
					placeholder="Ingresa tu email.."
					/>
					<span class="icon is-small is-left">
						<font-awesome-icon icon="envelope" />
					</span>
				</div>
				<p
				v-for="(error, key) in errors.email"
				:key="key"
				class="help is-danger"
				>
				{{ error }}
			</p>
		</div>
		<div class="field">
			<div class="control has-icons-left">
				<input
				class="input"
				:class="errors.password ? 'is-danger' : ''"
				v-model="password"
				type="password"
				placeholder="Ingresa tu contraseña.."
				/>
				<span class="icon is-small is-left">
					<font-awesome-icon icon="lock" />
				</span>
			</div>
			<p
			v-for="(error, key) in errors.password"
			:key="key"
			class="help is-danger"
			>
			{{ error }}
		</p>
	</div>
	
	<div class="level">
		<div class="level-left">
			<div class="level-item">
				<button class="button is-primary is-fullwidth" :disabled="loginButtonDisable">Iniciar Sesión</button>
			</div>
			<div class="level-item">
				<button class="button is-text is-fullwidth" @click.prevent="recuperarContra">Olvide mi contraseña</button>
			</div>
		</div>
		<div class="level-right">
			<div class="level-item">
				<FacebookLoginButton v-on:success="fbSuccess" v-on:failed="fbFailed" />
			</div>
			<div class="level-item">
				<GoogleLoginButton v-on:success="googleSuccess" v-on:error="googleFailed" />
			</div>
		</div>
	</div>
</form>

<form action="" v-if="recuperar" @submit.prevent="passRecovery">
	<div class="field">
		<p>Ingresa tu email y haz click en Recuperar Contraseña</p>
	</div>
	<div class="field">
		<div class="control has-icons-left ">
			<input
			class="input"
			:class="errors.email ? 'is-danger' : ''"
			v-model="email"
			type="email"
			placeholder="Ingresa tu email.."
			required :disabled="recoverSubmitted"
			/>
			<span class="icon is-small is-left">
				<font-awesome-icon icon="envelope" />
			</span>
		</div>
		<p
		v-for="(error, key) in errors.email"
		:key="key"
		class="help is-danger"
		>
		{{ error }}
	</p>
</div>

<article class="message is-info" v-if="recoverSubmitted">
	<div class="message-body">En unos minutos recibiras un correo a <strong>{{email}}</strong> con instrucciones para recuperar tu contraseña</div>
</article>

<div class="level">
	<div class="level-left">
		<div class="level-item">
			<button class="button is-primary" :disabled="recoverButtonDisable">Recuperar Contraseña</button>
		</div>
		<div class="level-item">
			<button class="button is-light" @click.prevent="clear">Cancelar</button>
		</div>
	</div>
</div>
</form>

</div>
</template>

<script>
	import ModalHeaderTitle from '@/components/ModalHeaderTitle'
	import FacebookLoginButton from '@/components/FacebookLoginButton'
	import GoogleLoginButton from '@/components/GoogleLoginButton'
	import { mapState } from 'vuex'

	export default {
		components: { ModalHeaderTitle, FacebookLoginButton, GoogleLoginButton },
		name: "Login",
		data() {
			return {
				email: "",
				password: "",
				errors: [],
				recuperar: false,
				recoverSubmitted: false,
				recoverButtonDisable: false,
				loginButtonDisable: false
			};
		},
		computed: {
			...mapState('login',['gotoRoute'])
		},
		methods: {
			login() {
				this.loginButtonDisable = true
				this.$store
				.dispatch("user/login", {
					email: this.email,
					password: this.password
				})
				.then(resp => {
					setTimeout(() => {
						this.loginButtonDisable = false
					}, 3000);
					if (resp) {
						this.errors = resp.data;
						if (resp.usuarioNoRegistrado) {
							this.$emit('tryRegister')
						}
					} else {
						this.$router.push(this.gotoRoute)
						.then(() => {
							this.$emit('tryCloseModal')
						})
						.catch(err => {
							//maybe verification missing
							console.log(err)
							//Close login modal
							this.$emit('tryCloseModal',{unir_quiniela: true})
						})
					}
				})
			},
			passRecovery(){
				this.recoverButtonDisable = true
				this.$store.dispatch('user/passrecover',{ email: this.email })
				.then(resp => {
					if (!resp.error) {
						this.recoverSubmitted = resp
						setTimeout(() => {
							this.recoverButtonDisable = false
						}, 3000);
					}else{
						this.recoverButtonDisable = false
					}
				});
			},
			recuperarContra(){
				this.recuperar = true;
			},
			clear(){
				this.recuperar = false
			},
			googleSuccess(googleUser){
				this.$store.dispatch('user/loginGoogle',{
					token: googleUser.getAuthResponse(true).access_token,
					googleUser: googleUser
				})
				.then(resp => {
					console.log(resp)
					if (resp) {
						if (resp.usuarioNoRegistrado) {
							this.$emit('tryRegister')
						}
					}else{
						this.$router.push(this.gotoRoute)
						.then(() => {
							this.$emit('tryCloseModal')
						})
						.catch(err => {
							//maybe verification missing
							console.log(err)
							//Close login modal
							this.$emit('tryCloseModal',{unir_quiniela: true})
						})
                	}
                })
			},
			googleFailed(error){
				console.log(error.error);
			},
			fbSuccess(resp){
				//Traer info usuario
				window.FB.api('me?fields=email,name', user => { 
					this.$store.dispatch('user/loginFacebook',{
						token: resp.authResponse.accessToken,
						facebookUser: user
					})
					.then(response => {
						console.log(response)
						if (response) {
							if (response.usuarioNoRegistrado) {
								//Intentar registrar al usuario
								this.$emit('tryRegister')
							}
						}else{
							this.$router.push(this.gotoRoute)
							.then(() => {
								this.$emit('tryCloseModal')
							})
							.catch(err => {
								//Verification missing
								console.log(err)
								//Close login modal
								this.$emit('tryCloseModal',{unir_quiniela: true})
							})
	                	}
					})
					.catch(err => {
						console.log(err)
					})
				})
			},
			fbFailed(){
				console.log('Fallo el inicio de sesion con FB')
			},
			closeLogin(){
				this.$emit('tryCloseModal')
			}
		}
	};
</script>

<style lang="css" scoped>

</style>
